<template>
  <div class="d-flex">
    <span class="d-flex gap-1" v-html="showAppliedFilters()" />
    <v-divider class="mx-5" vertical />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminInvoicesFiltersValues',

  props: {
    host: {
      type: Object,
      default: null,
    },

    customer: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapGetters(['filters']),
  },

  methods: {
    value(title, value) {
      return `
        <div>
          <span class="d-block caption grey--text text--darken-1 font-weight-bold text-truncate mw-100">${title}</span>
          <span class="d-block body-2 grey--text text-truncate mw-200">${value}</span>
        </div>
      `
    },

    showStartEndDate() {
      const filterDate = this.$parent.$refs.filterDate
      const dateRange = filterDate?.label
      const label = this.$t('filters.dates')

      return this.value(label, dateRange ?? this.$t('filters.date.recent'))
    },

    showReceiver() {
      const receiver = this.filters?.receiver
      const label = this.$t('filters.receiver')
      const value = this.$t(`hausefulInvoices.${receiver}`)

      if (!receiver) return ''
      return this.value(label, value)
    },

    showHost() {
      const label = this.$t('filters.host')
      const hostName = this.host?.name

      if (!hostName) return ''
      return this.value(label, hostName)
    },

    showCustomer() {
      const label = this.$t('filters.customer')
      const customerName = this.customer?.name

      if (!customerName) return ''
      return this.value(label, customerName)
    },

    showHasTransfer() {
      const label = this.$t('filters.transfer')
      const value = this.filters?.hasTransfer ? this.$t('filters.yes') : this.$t('filters.no')

      return this.value(label, value)
    },

    showSubscriptionType() {
      const subscriptionType = this.filters?.subscriptionType
      if (!subscriptionType || subscriptionType.length === 0) return ''

      const label = this.$t('filters.subscriptionType')
      const types = Array.isArray(subscriptionType) ? subscriptionType : [subscriptionType]
      const value = types.map(t => this.$t(`realEstate.subscriptionTypes.${t}`)).join(', ')

      return this.value(label, value)
    },

    showAppliedFilters() {
      return `
        ${this.showStartEndDate()}
        ${this.showReceiver()}
        ${this.showHost()}
        ${this.showCustomer()}
        ${this.showHasTransfer()}
        ${this.showSubscriptionType()}
      `
    },
  },

  data() {
    return {
      hostLoading: false,
      realEstateLoading: false,
    }
  }
}
</script>
